// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__O-3F1","actions":"GroupTable_actions__1abNv","deleteModalFooter":"GroupTable_deleteModalFooter__3TfpN"};